/**
 *    Copyright 2018 the original author or authors
 *
 *    Licensed under the Apache License, Version 2.0 (the "License");
 *    you may not use this file except in compliance with the License.
 *    You may obtain a copy of the License at
 *
 *        http://www.apache.org/licenses/LICENSE-2.0
 *
 *    Unless required by applicable law or agreed to in writing, software
 *    distributed under the License is distributed on an "AS IS" BASIS,
 *    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *    See the License for the specific language governing permissions and
 *    limitations under the License.
 */
import * as tslib_1 from "tslib";
import { NgModule, InjectionToken } from '@angular/core';
import { MatDialogModule } from '@angular/material';
import { ExtRestConfig } from './models';
import { DeleteDialogModule } from './dialog-delete/delete-dialog.module';
import { RestService } from './rest.service';
export var EXT_REST_CONFIG = new InjectionToken('extRest.config');
export function restFactory(config) {
    return new ExtRestConfig(config);
}
export var REST_PROVIDER = {
    provide: ExtRestConfig,
    useFactory: restFactory,
    deps: [EXT_REST_CONFIG]
};
/**
 * Base for REST module
 * @author Randika Hapugoda
 */
var ExtendzRestModule = /** @class */ (function () {
    function ExtendzRestModule() {
    }
    ExtendzRestModule_1 = ExtendzRestModule;
    ExtendzRestModule.forRoot = function (config) {
        return {
            ngModule: ExtendzRestModule_1,
            providers: [
                {
                    provide: EXT_REST_CONFIG,
                    useValue: config
                },
                REST_PROVIDER
            ]
        };
    }; // forRoot()
    ExtendzRestModule = ExtendzRestModule_1 = tslib_1.__decorate([
        NgModule({
            imports: [MatDialogModule, DeleteDialogModule],
            providers: [RestService]
        })
    ], ExtendzRestModule);
    return ExtendzRestModule;
    var ExtendzRestModule_1;
}()); // class
export { ExtendzRestModule };
//# sourceMappingURL=extendz-rest.module.js.map